import { all } from 'redux-saga/effects';
import runPayroll from './run-payroll-new-saga';

export default function* rootSaga(action) {
	yield all([runPayroll(action)]);
}
